import { createContext } from 'react';

const RegisterContext = createContext();
// export const CommentContext = createContext();
export default RegisterContext;